export default {
    title: 'Отчет от подрядчика',
    comment: {
        title: 'Комментарий',
        placeholder: '-',
    },
};
